import { useEffect, useRef } from 'react';

import type { MtxTooltipAnchor } from '@meilleurtaux/mtp-uikit-react';
import type { ComponentRef } from 'react';

type TooltipAnchorElement = ComponentRef<typeof MtxTooltipAnchor>;

/**
  When tab navigating, we have a stop inside MtxTooltipAnchor's shadow DOM
  This is to prevent this.
 */
const useRemoveTooltipAnchorTabStop = () => {
  const anchorRef = useRef<TooltipAnchorElement>(null);

  useEffect(() => {
    const shadowRoot = anchorRef.current?.shadowRoot;

    if (!shadowRoot) return;

    const removeTabStop = () => {
      const wrapper = shadowRoot.querySelector('.tooltip-anchor');
      wrapper?.removeAttribute('tabindex');

      return Boolean(wrapper);
    };

    // Stencil renders the shadow DOM asynchronously: watch for the wrapper when it is not there yet.
    if (removeTabStop()) return;

    const observer = new MutationObserver(() => {
      if (removeTabStop()) observer.disconnect();
    });

    observer.observe(shadowRoot, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return anchorRef;
};

export default useRemoveTooltipAnchorTabStop;
